import {
  COLLABORATOR_ROLE,
  COMMERCIAL_ROLE,
  RECRUITER_ROLE,
  SUPER_ADMIN_ROLE,
} from 'helper/roles';

const sameId = (a, b) => Boolean(a) && Boolean(b) && String(a) === String(b);

/**
 * Who may move a company from one stage to another (client, old, new, lost,
 * back to prospect): the agency manager, or the commercial the company is
 * given to. A company without a commercial is the agency manager's alone.
 * `crm` is the state of admin/crm/company/crm, `user` the signed-in one.
 */
export const canChangeStage = (crm, user) => {
  if (!user) return false;
  if (user.role === SUPER_ADMIN_ROLE) return true;
  return sameId(crm?.commercialId, user._id ?? user.id);
};

/**
 * The stage moves the « Actions » menu offers, by the state of the api: none
 * to whoever may not make them. A client is an old one once oldClientSince is
 * set, and only by hand (JBWEB-1423).
 */
export const stageMovesOf = (crm, user) => {
  if (!crm?.stage || !canChangeStage(crm, user))
    return { toOld: false, toNew: false, markLost: false, toProspect: false };
  const client = crm.stage === 'client';
  return {
    toOld: client && !crm.oldClientSince,
    toNew: client && Boolean(crm.oldClientSince),
    markLost: crm.stage !== 'lost',
    toProspect: crm.stage === 'lost',
  };
};

// « Ajouter une entreprise » (decision X6, widened on 31/10/2026): a prospect
// is added by every role of the CRM; a client company by the agency manager,
// the Commercial or the collaborator.
const PROSPECT_ADDERS = [SUPER_ADMIN_ROLE, COMMERCIAL_ROLE, COLLABORATOR_ROLE, RECRUITER_ROLE];
const CLIENT_ADDERS = [SUPER_ADMIN_ROLE, COMMERCIAL_ROLE, COLLABORATOR_ROLE];

export const canAddProspect = (role) => PROSPECT_ADDERS.includes(Number(role));
export const canAddClient = (role) => CLIENT_ADDERS.includes(Number(role));

// The types the « Type » field offers to a role, prospect first.
export const addableCompanyTypes = (role) => [
  ...(canAddProspect(role) ? ['prospect'] : []),
  ...(canAddClient(role) ? ['client'] : []),
];
